import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import MobileTaskSize from '../MobileTaskSize/';

const prices = {
  'Extra small': [
    '$23.75',
    '$25.00',
    '$26.25',
    '$28.75',
    '$32.50',
    '$37.50',
    '$45.00',
    '$57.50',
  ],
  'Small': [
    '$52.25',
    '$55.00',
    '$57.75',
    '$63.25',
    '$71.50',
    '$82.50',
    '$99.00',
    '$126.50',
  ],
  'Medium': [
    '$104.50',
    '$110.00',
    '$115.50',
    '$126.50',
    '$143.00',
    '$165.00',
    '$198.00',
    '$253.00',
  ],
  'Large': [
    '$190.00',
    '$200.00',
    '$210.00',
    '$230.00',
    '$260.00',
    '$300.00',
    '$360.00',
    '$460.00',
  ],
}

export default function Calculations(props) {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [selectedSize, setSelectedSize] = useState('Small')
  const deadlines = [
    '14 days',
    '7 days',
    '5 days',
    '3 days',
    '48 hours',
    '24 hours',
    '8 hours',
    '4 hours',
  ];
  const renderedDeadline = deadlines.map(deadline => {
    return (
      <span key={deadline} className="table-column__cell">{deadline}</span>
    )
  })
  const renderedColumns = Object.entries(prices).map(col => {
    return (
      <div className="table-column" key={col[0]} data-service-type={col[0]}>
        <span className="table-column__label">{col[0]}</span>
        {col[1].map(item => <span key={item} className="table-column__cell">{item}</span>)}
      </div>
    )
  });

  const onResize = (e) => {
    setTimeout(() => {
      setWindowSize(e.target.innerWidth);
    }, 500);
  }

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);

  return (
    <Fragment>
      <MobileTaskSize
        setSelectedSize={setSelectedSize}
      />
      <div className="service-table" style={{
        gridTemplateColumns: `repeat(${Object.keys(prices).length + 1}, 1fr)`
      }}>
        <div className="table-column">
          <span className="table-column__label">&nbsp;</span>
          {renderedDeadline}
        </div>
        {windowSize > 1024 && renderedColumns}
        {windowSize < 1024 && (
          <div className="table-column">
            <span className="table-column__label">&nbsp;</span>
            {prices[selectedSize].map(item => {
              return (
                <span key={item} className="table-column__cell">{item}</span>
              );
            })}
          </div>
        )}
      </div>
    </Fragment>
  )
}
